import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { PublishedConnectionRevision } from '../types/PublishedConnectionRevision';

export interface GetPublishedConnectionVersionsParams extends IGetItemsParams {
}

export interface GetPublishedConnectionVersionsResult extends IGetItemsResult {
  versions: PublishedConnectionRevision[];
}

export class GetPublishedConnectionVersionsRequest extends Request<GetPublishedConnectionVersionsParams, GetPublishedConnectionVersionsResult> {
  constructor(params: GetPublishedConnectionVersionsParams) {
    super('getPublishedConnectionVersions', params);
  }
}
